import * as React from 'react';

export interface ILIRIconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const LIRIcon = React.forwardRef<SVGSVGElement, ILIRIconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404 0 0 1.0404 -98.016 -47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-203.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <text x="97.087555" y="47.709003" fontFamily="sans-serif" fontSize="4.6513px" xmlSpace="preserve">
                  <tspan x="97.087555" y="47.709003" strokeWidth=".0072031" />
                </text>
                <g aria-label="T1">
                  <g transform="scale(.97813 1.0224)" strokeWidth=".0024692" aria-label="I">
                    <path
                      d="m101.31 46.109q-0.1962 0-0.1962-0.1962v-3.5317q0-0.1962 0.1962-0.1962 0.19621 0 0.19621 0.1962v3.5317q0 0.1962-0.19621 0.1962z"
                      strokeWidth=".0024692"
                    />
                  </g>
                  <g transform="scale(.97813 1.0224)" strokeWidth=".0024692" aria-label="L">
                    <path
                      d="m98.978 42.346q0-0.1962 0.1962-0.1962 0.1962 0 0.1962 0.1962v3.3355h1.3734q0.1962 0 0.1962 0.1962 0 0.1962-0.1962 0.1962h-1.5696q-0.1962 0-0.1962-0.1962z"
                      strokeWidth=".0024692"
                    />
                  </g>
                  <g transform="scale(.92423 1.082)" strokeWidth=".0023331" aria-label="R">
                    <path
                      d="m109.36 42.02 0.64606 1.2921q0.0225 0.04494 0.0225 0.08427 0 0.07303-0.0562 0.12921-0.0562 0.05618-0.12922 0.05618-0.11797 0-0.16853-0.10393l-0.69101-1.382q-0.0253 0.0028-0.0674 0.0028h-0.74157v1.2977q0 0.18539-0.18539 0.18539t-0.18539-0.18539v-3.337q0-0.18539 0.18539-0.18539h0.92696q0.46348 0 0.78651 0.32584 0.32584 0.32303 0.32584 0.78651 0 0.76685-0.66854 1.0337zm-1.1854-1.7753v1.4831h0.74157q0.31179 0 0.52527-0.21348 0.21629-0.21629 0.21629-0.52809t-0.21629-0.52528q-0.21348-0.21629-0.52527-0.21629z"
                      strokeWidth=".0023331"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
